import { rootApi } from "../../api/rootApi";

export const membershipHistoryApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    

    fetchMembershipHistoryByMembershipId: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/membership-history/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    fetchMembershipHistoryExportByMembershipId: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/membership-history/export/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    fetchMembershipHistoryByAppUserID: builder.mutation({
        query: (params) => {
          console.log("calling getMembershipHistoryByAppUserID" , params);
          return {
            method: "GET",
            url: `/tenant/membership-history/user?membership_id=${params.membership_id}&app_user_id=${params.app_user_id}`,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + params.token,
              slug: params.tenant_id,
            },
          };
        },
      }),
  
      

  }),
});

export const {
  useFetchMembershipHistoryByMembershipIdMutation,
  useFetchMembershipHistoryByAppUserIDMutation,
  useFetchMembershipHistoryExportByMembershipIdMutation
} = membershipHistoryApi;
